import { render, staticRenderFns } from "./PsAvatar.vue?vue&type=template&id=37ee2cf1&scoped=true&"
import script from "./PsAvatar.vue?vue&type=script&lang=js&"
export * from "./PsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PsAvatar.vue?vue&type=style&index=0&id=37ee2cf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee2cf1",
  null
  
)

export default component.exports